import { useState, useEffect } from "react";
import PageLayout from "@/components/PageLayout";
import ProductCatalog from "@/components/ProductCatalog";
import SEO from "@/components/SEO";

const PRODUCTS_JSON_LD = {
  "@context": "https://schema.org",
  "@type": "ItemList",
  itemListElement: [
    { "@type": "Product", position: 1, name: "600 Lining", description: "Shrinkless single dyed cambric lining fabric, 336 colours, 83cm width." },
    { "@type": "Product", position: 2, name: "600 Gold", description: "New premium line — 600 Gold shrinkless single-dyed cambric with luxurious sheen, 336 colours, 84cm width." },
    { "@type": "Product", position: 3, name: "060 Lining", description: "Shrinkless double dyed cambric lining fabric, 336 colours, 84cm width." },
    { "@type": "Product", position: 4, name: "006 Lining", description: "Double dyed mercerized cambric lining fabric, 336 colours, 86cm width." },
    { "@type": "Product", position: 5, name: "6000 Shrinkless", description: "Shrinkless single dyed fabric, big panna, 336 colours, 110cm width." },
    { "@type": "Product", position: 6, name: "Super Queen", description: "Shrinkless single dyed fabric, big panna, 336 colours, 108cm width." },
    { "@type": "Product", position: 7, name: "303 Pure Cotton", description: "Pure cotton cambric lining fabric, small panna, 336 colours, 86cm width." },
    { "@type": "Product", position: 8, name: "3000 Pure Cotton", description: "Pure cotton cambric lining, big panna, 336 colours, 110cm width." },
    { "@type": "Product", position: 9, name: "American Crepe", description: "American Crepe lining fabric, big panna, 446 shades, 104cm width." },
  ],
};

export default function ProductsPage() {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
    fetch(`${API}/products`)
      .then((r) => r.json())
      .then(setProducts)
      .catch((e) => console.error("Products load failed:", e));
  }, []);

  return (
    <PageLayout>
      <SEO
        title="Lining Fabric Qualities — Cambric, Cotton & American Crepe | Mutha Paras & Co."
        description="Explore 9 premium lining fabric qualities — 600, 600 Gold, 060, 006, 6000 Shrinkless, Super Queen, Pure Cotton & American Crepe. 2,400+ shades, bulk stock ready to ship."
        path="/products"
        jsonLd={PRODUCTS_JSON_LD}
      />
      <ProductCatalog products={products} />
    </PageLayout>
  );
}
